import { reUpRPCCall } from './LSLoyaltyAPI';
import { getLsRetailSession, getReturnURLSession, getSignedURL } from './SessionManager';
import { isRetail, getEnvironmentString } from './Utils';
import { navigateTo } from './AppActions';

var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
const localeDomain = "loyalty_retail_web_ui";

function Promise () {
	this._thens = [];
}

Promise.prototype = {
	then: function (onResolve, onReject) 
	{
		this._thens.push({ resolve: onResolve, reject: onReject });
	},

	resolve: function (val1, val2) { this._complete('resolve', val1, val2); },
	reject: function (ex) { this._complete('reject', ex); },

	_complete: function (which, arg1, arg2) 
	{
		this.then = which === 'resolve' ?
			function (resolve, reject) { resolve && resolve(arg1, arg2); } :
			function (resolve, reject) { reject && reject(arg1, arg2); };

		this.resolve = this.reject = 
			function () { throw new Error('Promise already completed.'); };

		var aThen, i = 0;
		while (aThen = this._thens[i++]) { aThen[which] && aThen[which](arg1, arg2); }
		delete this._thens;
	}
};

function rpcCall(method, params, promise, accountID, token)
{
	var environmentString = getEnvironmentString();
	var url = 'https://api.'+environmentString+'getreup.com/ls-retail/V1.0/'+accountID;
	// 2147483647 is PHP_INT_MAX for 32-bit systems (2^31 - 1). Using this ensures
	// the ID remains a valid integer when parsed by PHP backends, avoiding overflow
	// or conversion to float that could occur with larger values.
	let tracingId = Math.floor(Math.random() * 2147483647);
	let body = {
		method,
		params,
		id: tracingId
	};
	let fetchData = { 
		method: 'POST', 
		body: JSON.stringify(body),
		headers: {
			'Authorization': `Bearer ${getLsRetailSession()}`
		}
	}

	fetch(url, fetchData).then((resp) => resp.text()).then((respText)=> {
		return JSON.parse(respText);
	}).then((body) => {
		if( typeof body.error === 'undefined' || body.error == null || body.error.code == 0 ){
			promise.resolve(body.result, null)
		}
		else if (typeof body.error !== 'undefined' && body.error.code == JWT_AUTH_FAILURE_CODE) {
			promise.resolve(body.result, body.error)
			let urlInputs = {
				returnURL:getReturnURLSession()
			}
			// Handles the case where the session token has expired, or the feature has been turned on while they are logged in
			if (getSignedURL() != null) {
				navigateTo('/invalidSession', {
					urlInputs
				});
			} else {
				// handles the case where the user does not have a valid signature, this means they need to log out of R-Series and log back in
				navigateTo('/missingSignature', {
					urlInputs
				});
			}
		} else {
			promise.resolve(body.result, body.error)
		}
	}).catch((err)=>{
		console.log(err)
	})
}

export function checkCacheVersion(locale, cacheVersion, accountID = "")
{
	var p = new Promise();
	if( cacheVersion == null ) cacheVersion = 0;

	var params = [locale,
		cacheVersion,
		accountID,
		localeDomain];
	
	localizationRpcCall("ShouldUpdateTranslations", params, p, accountID);

	return p;
}

export function localizationRpcCall(method, params, promise, accountID)
{
	var environmentString = getEnvironmentString();
	var url = 'https://api.'+environmentString+'getreup.com/localization/V1.0/localization.php?accountID='+accountID;
	var body = {
		method,
		params,
		id:1
	};
	let fetchData = { 
		method: 'POST', 
		body: JSON.stringify(body),
	}
	fetch(url, fetchData).then((resp) => resp.text()).then((respText)=> 
	{
		// console.log("respText", respText);
		return JSON.parse(respText);
	}).then((body) => 
	{
		if( typeof body.error === 'undefined' || body.error == null || body.error.code == 0 )
		{
			var translatedStrings = body.result;
			var localizationVersion = body.localizationVersion;
			promise.resolve({translatedStrings, localizationVersion});
		}
		else
		{
			promise.resolve(body.result, body.error)
		}
	}).catch((err)=>
	{
		console.log(err)
	})
}

export function getUser(userID, hash, urlInputs = {accountID:""})
{
	var p = new Promise();
	rpcCall("GetGCUser", [userID, hash], p, urlInputs.accountID);

	return p;
}

export function spendCredit(userID, hash, amount, type, urlInputs = {accountID:""})
{
	var p = new Promise();
	rpcCall("UseCredit", [userID, amount, type, hash, "P", "0"], p, urlInputs.accountID);

	return p;
}

export function addRewardToSale(userID, hash, rewardID, type, urlInputs = {accountID:""})
{
	var p = new Promise();
	var params = isRetail() ? [userID, rewardID, type, hash, urlInputs.shopID, urlInputs.saleID] : [userID, rewardID, type, hash];
	rpcCall("AddRewardToSale", params, p, urlInputs.accountID);

	return p;
}

export function refundTransaction(transactionID, urlInputs = {accountID:""})
{
	var p = new Promise();
	rpcCall("RefundTransaction", [transactionID], p, urlInputs.accountID);

	return p;
}

export function getRewards(userID, hash, urlInputs = {accountID:"not-set"})
{
	var p = new Promise();
	rpcCall("GetRewards", [userID, hash], p, urlInputs.accountID);

	return p;
}

export function getOneTimeRewards(userID, hash, urlInputs = {accountID:""})
{
	var p = new Promise();
	rpcCall("GetOneTimeRewards", [userID, hash], p, urlInputs.accountID);

	return p;
}

export function lookUpUserByPhone(phoneNumber, urlInputs = {accountID:""})
{
	console.log("urlInputs",urlInputs)
	var p = new Promise();
	var params = isRetail() ? [urlInputs.customerID, phoneNumber] : [phoneNumber];
	rpcCall("LookUpUserByPhone", params, p, urlInputs.accountID);

	return p;
}

export function createUserByPhone(countryCode, phoneNumber, urlInputs = {accountID:""})
{
	var p = new Promise();
	var params = isRetail() ? [urlInputs.customerID, countryCode, phoneNumber] : [countryCode, phoneNumber];
	rpcCall("CreateAccountWithPhone", params, p, urlInputs.accountID);

	return p;
}

export function isFeatureFlagEnabled(urlInputs = {accountID:""}, featureFlagName)
{
	var p = new Promise();
	var params = [featureFlagName];
	rpcCall("IsFeatureFlagEnabled", params, p, urlInputs.accountID);

	return p;
}
export function isDuplicateEmailExists(urlInputs = {accountID:""}, emailAddress)
{
	var p = new Promise();
	var params = [emailAddress];
	rpcCall("CheckEmailExists", params, p, urlInputs.accountID);

	return p;
}

export function resendPortalLink(userID, hash, urlInputs = {accountID:""})
{
	var p = new Promise();
	rpcCall("ResendVerification", [userID, hash], p, urlInputs.accountID);

	return p;
}

export function getQualifiedDiscounts(userID, hash, transType, rawInvoice, urlInputs = {accountID:""})
{
	var params = null;
	if( isRetail() )
	{
		params = [userID, "*", transType, hash, urlInputs.saleID];
	}
	else
	{
		var items = [];
		if( typeof rawInvoice.receiptItems !== 'undefined' )
		{
			var receiptItems = JSON.parse(rawInvoice.receiptItems);
			for( var i = 0; i < receiptItems.length; i++ )
			{
				var item = {
					product_id: receiptItems[i].plu,
					item_qty: receiptItems[i].amount,
					item_amount: receiptItems[i].totalPrice
				}
				items.push(item);
			}
		}
		var invoice = {items};
		params = [userID, "*", transType, hash, invoice];
	}
	
	var p = new Promise();
	rpcCall("EvaluateReward", params, p, urlInputs.accountID);

	return p;
}

export function checkIn(userID, hash, urlInputs = {accountID:""})
{
	var p = new Promise();
	var params = isRetail() ? [userID, hash, urlInputs.shopID, urlInputs.saleID] : [userID, hash];
	rpcCall("CheckIn", params, p, urlInputs.accountID);

	return p;
}

export function evaluateCheckIn(userID, hash, urlInputs = {accountID:""})
{
	var p = new Promise();
	var params = isRetail() ? [userID, hash, urlInputs.shopID, urlInputs.saleID] : [userID, hash];
	rpcCall("EvaluateCheckIn", params, p, urlInputs.accountID);

	return p;
}

export function getExternalUser(externalUserID, urlInputs = {accountID:""})
{
	var p = new Promise();
	var params = isRetail() ? [externalUserID] : [externalUserID];
	rpcCall("GetExternalUser", params, p, urlInputs.accountID);

	return p;
}

export function getLocalizedString(locale, localeKey, localeParams = [], accountID = "")
{
	var p = new Promise();
	var appID = "";
	console.log(locale, localeKey, localeParams);
	var params = [locale,
				localeKey,
				localeParams,
				appID,
				localeDomain];

	localizationRpcCall("GetLocalizedString", params, p, accountID);

	return p;
}

export function getLocalizedStrings(locale, localeKeys, localeParams = [[]], accountID  =  "")
{
	var p = new Promise();
	var appID = "";
	var params = [locale,
				localeKeys,
				localeParams,
				appID,
				localeDomain];
	localizationRpcCall("GetLocalizedStrings", params, p, accountID);

	return p;
}

export function setSaleUser(userID, saleID, urlInputs = {accountID:""})
{
	var p = new Promise();
	var params = isRetail() ? [userID, saleID] : [userID, saleID];
	rpcCall("SetSaleUser", params, p, urlInputs.accountID);

	return p;
}

export function checkPhoneNumberValidity(countryCode, phoneNumber, urlInputs = {accountID:""})
{
	var p = new Promise();
	var params = isRetail() ? [countryCode, phoneNumber] : [countryCode, phoneNumber];
	rpcCall("CheckPhoneNumberValidity", params, p, urlInputs.accountID);

	return p;
}

export function login(signedURL, accountID)
{
	var p = new Promise();
	rpcCall("Login", [signedURL], p, accountID);

	return p;
}

export const LOGIN_ERROR_CODE = -1;

const JWT_AUTH_FAILURE_CODE = -800;